import moment = require("moment");
import React = require("react");
import {Moment} from "moment";

// tslint:disable-next-line:no-implicit-dependencies
import {Subscription} from "rxjs";
import {RestDataLoader} from "../../../../dashboard/widgets/unilever/RestDataLoader";
import {Loader} from "../../../../components/Utils/loader/Loader";
import {CoffeeConsumptionStatistics} from "../data/CoffeeMachineJsonMapper";
import {WidgetsPageData} from "../data/WidgetsPageData";
import {JSONCoffeeMachineTexts} from "./CoffeeMachineDashboard";

import RangedDatePickerController from "../../../../components/rangeddatepicker/RangedDatePickerController";
import {TABLE_PAGE_SIZE} from "./CoffeeMachineTablePage";
import {ContinueDispensingConsumptionsWidget} from "./components/widgets/ContinueDispensingConsumptionsWidget";
import {PieChartWidget} from "./components/widgets/PieChartWidget";
import {Statistic} from "./components/widgets/Statistic";

import {WashesWidget} from "./components/widgets/WashesWidget";
import {WidgetController} from "./components/widgets/WidgetController";

interface WidgetProps {
    equipmentGuid: string;
    texts: JSONCoffeeMachineTexts;
    dateRangeController: RangedDatePickerController;
}

interface WidgetState {
    widgetsData: WidgetsPageData;
    widgetsDataOnlyContinueConsumption: WidgetsPageData;
    startDate: Moment;
    endDate: Moment;
}

export class CoffeeMachineWidgetsPage extends React.Component<WidgetProps, WidgetState> {

    private dateRangeController: RangedDatePickerController;
    private widgetController: WidgetController;

    private listener: Subscription;

    constructor(props: WidgetProps) {
        super(props);

        this.dateRangeController = props.dateRangeController;

        this.widgetController = new WidgetController();

        this.state = {
            widgetsData: new WidgetsPageData(),
            widgetsDataOnlyContinueConsumption: new WidgetsPageData(),
            startDate: moment(props.dateRangeController.startDate),
            endDate: moment(props.dateRangeController.endDate),
        };
    }

    public render() {
        const data = this.state.widgetsData;
        if (!data.loaded()) {
            return <Loader/>;
        }
        let purgeAvg = 0;
        if (data.getConsumptionsOnActiveDays() > 0) {
            purgeAvg = (data.getPurges() / data.getConsumptionsOnActiveDays()) * 100;
        }
        let automaticWashesAvg = 0;
        if (data.getAutomaticWashes() > 0 && this.state.widgetsData.getNumberOfActiveDays() > 0) {
            automaticWashesAvg = data.getAutomaticWashes() / this.state.widgetsData.getNumberOfActiveDays();
        }
        let manualWashesAvg = 0;
        if (data.getManualWashes() > 0 && this.state.widgetsData.getNumberOfActiveDays() > 0) {
            manualWashesAvg = data.getManualWashes() / this.state.widgetsData.getNumberOfActiveDays();
        }

        return (
            <div className="coffee-machine-widgets-page">
                <div className="f-grid dashboard-container">
                    <ContinueDispensingConsumptionsWidget
                        texts={this.props.texts.continueConsumptionsWidgetTexts}
                        data={data.getConsumptionsStatistics()}
                        controller={this.widgetController}
                        width={"small"}
                        key={"coffee-machine-1"}
                    />
                    <PieChartWidget
                        texts={this.props.texts.dispensingTimeAvgWidgetTexts}
                        data={data.getConsumptionsStatistics()[Statistic.dispensingTime.name]}
                        controller={this.widgetController}
                        width={"small"}
                        thresholds={[0, 21000, 28000, Infinity]}
                        type={"dispensingTime"}
                        key={"coffee-machine-2"}
                    />
                    <PieChartWidget
                        texts={this.props.texts.dispensingPressureAvgWidgetTexts}
                        data={data.getConsumptionsStatistics()[Statistic.pumpPressure.name]}
                        thresholds={[0, 8000, 10000, Infinity]}
                        type={"pumpPressure"}
                        controller={this.widgetController}
                        width={"small"}
                        key={"coffee-machine-3"}
                    />
                    <WashesWidget
                        texts={this.props.texts.washesWidgetTexts}
                        data={{
                            automaticWashesAvg,
                            manualWashesAvg,
                            purgesPerc: purgeAvg,
                            numberActiveDays: data.getNumberOfActiveDays(),
                        }}
                        key={4}
                        controller={this.widgetController}
                        width={"small"}
                    />
                    <PieChartWidget
                        texts={this.props.texts.boilerPressureAvgWidgetTexts}
                        data={data.getConsumptionsStatistics()[Statistic.serviceBoilerPressure.name]}
                        thresholds={[0, 1000, 1300, Infinity]}
                        type={"boilerServicesPressure"}
                        controller={this.widgetController}
                        width={"small"}
                        key={"coffee-machine-5"}
                    />
                    <PieChartWidget
                        texts={this.props.texts.fluxAvgWidgetTexts}
                        data={data.getConsumptionsStatistics()[Statistic.flow.name]}
                        thresholds={[0, 0.8, 1.2, Infinity]}
                        type={"waterFlowSpeed"}
                        controller={this.widgetController}
                        width={"small"}
                        key={"coffee-machine-6"}
                    />
                </div>
            </div>
        );
    }

    public componentDidMount(): void {
        this.loadWidgetsData();

        this.listener = this.dateRangeController.listen(({start, end}) => {
            this.loadWidgetsData();
        });
    }

    public componentWillUnmount() {
        if (this.listener) {
            this.listener.unsubscribe();
        }
    }

    private loadWidgetsData() {
        const widgetsData0 = this.state.widgetsData.clone();
        widgetsData0.reset();
        widgetsData0.setLoading(true);
        this.setState({widgetsData: widgetsData0});
        RestDataLoader.loadData(
            "equipment/" + this.props.equipmentGuid + "/activeDays",
            {
                startDate: moment(this.dateRangeController.startDate)
                    .startOf("day")
                    .format("YYYY-MM-DD")
                    .toString(),
                endDate: moment(this.dateRangeController.endDate)
                    .add(1, "day")
                    .endOf("day")
                    .format("YYYY-MM-DD")
                    .toString(),
            },
            (data: any) => {
                const widgetsData = this.state.widgetsData.clone();
                widgetsData.setNumberOfActiveDays(data.list.length);
                widgetsData.setLoading(!widgetsData.loaded());
                this.setState({widgetsData});
            },
            () => {
                console.error("Error requesting data");
            },
        );
        RestDataLoader.loadData(
            "equipment/coffeeMachines/" + this.props.equipmentGuid + "/purges",
            {
                startDate: moment(this.dateRangeController.startDate)
                    .startOf("day")
                    .format("YYYY-MM-DDTHH:mm").toString(),
                endDate: moment(this.dateRangeController.endDate).endOf("day").format("YYYY-MM-DDTHH:mm").toString(),
                onlyActiveDays: true,
            },
            (data: any) => {
                const purges = data.total;
                const widgetsData = this.state.widgetsData.clone();
                widgetsData.setPurges(purges);
                widgetsData.setLoading(!widgetsData.loaded());
                this.setState({widgetsData});
            },
            () => {
                console.error("Error requesting data");
            },
        );
        RestDataLoader.loadData(
            "equipment/coffeeMachines/" + this.props.equipmentGuid + "/consumptions",
            {
                startDate: moment(this.dateRangeController.startDate)
                    .startOf("day").format("YYYY-MM-DDTHH:mm").toString(),
                endDate: moment(this.dateRangeController.endDate).endOf("day").format("YYYY-MM-DDTHH:mm").toString(),
                onlyActiveDays: true,
            },
            (data: any) => {
                const consumptions = data.total;
                const widgetsData = this.state.widgetsData.clone();
                widgetsData.setConsumptionsOnActiveDays(consumptions);
                widgetsData.setLoading(!widgetsData.loaded());
                this.setState({widgetsData});
            },
            () => {
                console.error("Error requesting data");
            },
        );
        RestDataLoader.loadData(
            "equipment/coffeeMachines/" + this.props.equipmentGuid + "/consumptions",
            {
                startDate: moment(this.dateRangeController.startDate)
                    .startOf("day").format("YYYY-MM-DDTHH:mm").toString(),
                endDate: moment(this.dateRangeController.endDate).endOf("day").format("YYYY-MM-DDTHH:mm").toString(),
                limit: TABLE_PAGE_SIZE,
            },
            (data: any) => {
                const consumptionsList = data.list;
                const consumptions = data.total;
                const widgetsData = this.state.widgetsData.clone();
                widgetsData.setConsumptions(consumptions);
                widgetsData.setConsumptionsList(consumptionsList);
                widgetsData.setLoading(!widgetsData.loaded());
                this.setState({widgetsData});
            },
            () => {
                console.error("Error requesting data");
            },
        );
        RestDataLoader.loadData(
            "equipment/coffeeMachines/" + this.props.equipmentGuid + "/consumptions/statistics",
            {
                startDate: moment(this.dateRangeController.startDate)
                    .startOf("day").format("YYYY-MM-DDTHH:mm").toString(),
                endDate: moment(this.dateRangeController.endDate).endOf("day").format("YYYY-MM-DDTHH:mm").toString(),
            },
            (data: CoffeeConsumptionStatistics) => {
                const widgetsData = this.state.widgetsData.clone();
                widgetsData.setConsumptionsStatistics(data);
                widgetsData.setLoading(!widgetsData.loaded());
                this.setState({widgetsData});
            },
            () => {
                console.error("Error requesting data");
            },
        );
        RestDataLoader.loadData(
            "equipment/coffeeMachines/" + this.props.equipmentGuid + "/washes",
            {
                startDate: moment(this.dateRangeController.startDate)
                    .startOf("day")
                    .format("YYYY-MM-DDTHH:mm").toString(),
                endDate: moment(this.dateRangeController.endDate).endOf("day").format("YYYY-MM-DDTHH:mm").toString(),
                onlyActiveDays: true,
            },
            (data: any) => {
                let automaticWashes = 0;
                let manualWashes = 0;
                let lastDate = null;
                data.list.forEach((d) => {
                    if (!d.manual) {
                        const currentDate = new Date(d.date);
                        currentDate.setHours(0, 0, 0, 0);
                        // Filter all the washes in the same day
                        if (d.count > 0 && (lastDate == null || currentDate.getTime() !== lastDate.getTime())) {
                            automaticWashes++;
                            lastDate = currentDate;
                        }
                    }
                });
                lastDate = null;
                data.list.forEach((d) => {
                    if (d.manual) {
                        const currentDate = new Date(d.date);
                        currentDate.setHours(0, 0, 0, 0);
                        // Filter all the washes in the same day
                        if (d.count > 0 && (lastDate == null || currentDate.getTime() !== lastDate.getTime())) {
                            manualWashes++;
                            lastDate = currentDate;
                        }
                    }
                });
                const widgetsData = this.state.widgetsData.clone();
                widgetsData.setAutomaticWashes(automaticWashes);
                widgetsData.setManualWashes(manualWashes);
                widgetsData.setLoading(!widgetsData.loaded());
                this.setState({widgetsData});
            },
            () => {
                console.error("Error requesting data");
            },
        );
    }

}
